import React, { useState } from "react";
import './Bill.css';
import { useNavigate } from 'react-router-dom';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button } from '@mui/material';

const Bill = ({ status, filters, selectedRows }) => {
    const isCompanyFilterApplied = filters.companyId;
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);

    const handleGenerateBill = (userChoice) => {
        const requestPayload = {
            companyId: filters.companyId,
            tripIds: userChoice ? selectedRows : selectedRows,
            timeFrom: filters.startTime ? new Date(filters.startTime).getTime() / 1000 : 0,
            timeTo: filters.endTime ? new Date(filters.endTime).getTime() / 1000 : 1993456000,
        };

        console.log("Request Payload:", requestPayload);

        // Navigate to draft invoice page with the request payload
        navigate("/login/draft_invoice", { state: { companyId: requestPayload.companyId, tripIds: requestPayload.tripIds, timeFrom: requestPayload.timeFrom, timeTo: requestPayload.timeTo } });
    };

    const handleClick = () => {
        if (isCompanyFilterApplied) {
            setOpen(true);
        } else {
            alert("Please apply a company filter to generate a bill.");
        }
    };

    const handleClose = () => setOpen(false);
    const handleConfirm = (userChoice) => {
        setOpen(false);
        handleGenerateBill(userChoice);
    };

    return (
        <div className="bill-bar">
            {status === 'COMPLETED' && (
                <>
                    <button className="custom-button" onClick={handleClick} disabled={!isCompanyFilterApplied}>
                        Generate Bill
                    </button>

                    <Dialog open={open} onClose={handleClose}>
                        <DialogTitle>Generate Bill</DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                Do you want to create a bill for the filters applied or the rows selected?
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => handleConfirm(true)} color="primary">
                                Filters Applied
                            </Button>
                            <Button onClick={() => handleConfirm(false)} color="primary" autoFocus>
                                Rows Selected
                            </Button>
                        </DialogActions>
                    </Dialog>
                </>
            )}
        </div>
    );
};

export default Bill;